import React from 'react';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { TechDocsReaderLayout } from '@backstage/plugin-techdocs';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';

export function SinglePageAwareReaderLayout() {
  const { entityRef, metadata } = useTechDocsReaderPage();
  const hideEntityHeader = [
    'component:default/spin-engineering-docs',
    'component:default/spin-engineering-cli',
  ].includes(stringifyEntityRef(entityRef));
  const isLoaded = !metadata.loading && metadata.value !== undefined;
  const files =
    (metadata.value as { files?: string[] } | undefined)?.files ?? [];
  const htmlFiles = Array.isArray(files)
    ? files.filter(
        (f: string) =>
          f.endsWith('.html') && f !== '404.html' && !f.startsWith('search/'),
      )
    : [];
  const hasOnlyOnePage = isLoaded && htmlFiles.length <= 1;
  return (
    <TechDocsReaderLayout
      withHeader={!hideEntityHeader}
      withSearch={!hasOnlyOnePage}
    />
  );
}
